export type RecordValue = Record<string, unknown>

export const asRecords = (value: unknown): RecordValue[] =>
  Array.isArray(value) ? (value as RecordValue[]) : []
export const label = (value: unknown) =>
  typeof value === 'string' || typeof value === 'number' ? String(value) : '—'
export const idOf = (item: RecordValue) =>
  label(item.id ?? item.slug ?? item.name)
export const titleOf = (item: RecordValue) =>
  label(item.name ?? item.title ?? item.id)
